import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "orbis-table-wrapper",
  class: "table-wrapper"
}
const _hoisted_2 = { class: "table-head" }
const _hoisted_3 = {
  key: 0,
  class: "head-icon"
}
const _hoisted_4 = {
  key: 0,
  class: "search-option-desktop"
}
const _hoisted_5 = {
  key: 0,
  class: "button-row"
}
const _hoisted_6 = { class: "dropdown-content-container" }
const _hoisted_7 = { class: "dropdown-content" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_sub_header = _resolveComponent("sub-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sub_header, {
        title: _ctx.state.tableName
      }, _createSlots({
        "title-buttons": _withCtx(() => [
          (_ctx.selectedTable.headIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedTable.headIcon)))
              ]))
            : _createCommentVNode("", true)
        ]),
        options: _withCtx(() => [
          (_ctx.searchOptions.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.searchType === 'string' || _ctx.searchType === 'array')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 0,
                      "model-value": _ctx.state.search,
                      placeholder: "search...",
                      style: {"width":"300px","margin":"auto 5px"},
                      autofocus: true,
                      onInput: _ctx.onChangeSearch,
                      onChange: _ctx.onChangeSearch
                    }, null, 8, ["model-value", "onInput", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.searchType === 'number')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 1,
                      "model-value": _ctx.state.searchNumFrom,
                      type: "number",
                      placeholder: "from...",
                      autofocus: true,
                      style: {"width":"150px","margin":"auto 5px"},
                      onInput: _ctx.onChangeSearchNumFrom,
                      onChange: _ctx.onChangeSearchNumFrom
                    }, null, 8, ["model-value", "onInput", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.searchType === 'number')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 2,
                      "model-value": _ctx.state.searchNumTo,
                      type: "number",
                      placeholder: "to...",
                      style: {"width":"150px","margin":"auto 5px"},
                      onInput: _ctx.onChangeSearchNumTo,
                      onChange: _ctx.onChangeSearchNumTo
                    }, null, 8, ["model-value", "onInput", "onChange"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_b_form_select, {
                  modelValue: _ctx.state.searchKey,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.searchKey) = $event)),
                  options: _ctx.searchOptions,
                  style: {"margin":"auto 0","width":"200px"},
                  onChange: _ctx.resetSearch
                }, null, 8, ["modelValue", "options", "onChange"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (_ctx.tableArray.length > 1)
          ? {
              name: "title",
              fn: _withCtx(() => [
                _createVNode(_component_b_form_select, {
                  modelValue: _ctx.state.tableKey,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tableKey) = $event)),
                  options: _ctx.tableOptions,
                  onChange: _ctx.onTableChange,
                  class: "table-selector"
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title"]),
      (_ctx.showTopRow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "toprow")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_b_table, {
      key: _ctx.state.tableName,
      "table-key": _ctx.state.tableKey,
      items: _ctx.filteredItems,
      fields: _ctx.filteredFields,
      "sticky-header": _ctx.computedStickyHeader,
      loading: _ctx.loading,
      "side-pane-options": _ctx.sidePaneOptions,
      "show-pagination": _ctx.showPagination,
      toggleRow: _ctx.toggleRow,
      "per-page": _ctx.perPage,
      onRowClick: _ctx.rowClick
    }, _createSlots({
      "head(action)": _withCtx(() => [
        (_ctx.dynamicColumns)
          ? (_openBlock(), _createBlock(_component_b_dropdown, {
              key: 0,
              class: "dropdown-filter",
              "no-caret": "",
              right: ""
            }, {
              "button-content": _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-table-columns",
                  style: {"font-size":"24px"}
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dropdown-content-head" }, "Columns", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTable.columnDefinition, (def) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: def.key,
                        class: "dropdown-content-row"
                      }, [
                        _createVNode(_component_b_form_checkbox, {
                          inline: "",
                          label: _ctx.getLabelFromFormDefinition(def),
                          "model-value": _ctx.state.dynamicColumns.some(x => _ctx.isEqual(x, def.key)),
                          onChange: (value) => _ctx.toggleColumn(value, def.key)
                        }, null, 8, ["label", "model-value", "onChange"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_8))
      ]),
      _: 2
    }, [
      _renderList(_ctx.slots, (slot, name) => {
        return {
          name: name,
          fn: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, name, {
              item: slotProps.item
            })
          ])
        }
      }),
      (_ctx.hasActionSlotOrField)
        ? {
            name: "cell(action)",
            fn: _withCtx((row) => [
              _renderSlot(_ctx.$slots, "action", {
                item: row.item
              })
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.hasSidePane)
        ? {
            name: "side-pane",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "side-pane", {}, () => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedTable.sidePane)))
              ])
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.hasSidePaneHead)
        ? {
            name: "side-pane-head",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "side-pane-head")
            ]),
            key: "2"
          }
        : undefined
    ]), 1032, ["table-key", "items", "fields", "sticky-header", "loading", "side-pane-options", "show-pagination", "toggleRow", "per-page", "onRowClick"]))
  ]))
}